import React, { Component } from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import * as constants from './constants/routes';
import Chat from './components/Chat';
import NotFound from './components/NotFound';
import Home from './components/Home';

class Routes extends Component {

  render() {
    return (
      <Switch>
        <Route exact from={constants.CHAT} path='/chat' component={Chat} />
        <Route exact from={constants.HOME} path='/home' component={Home} />
        <Redirect exact from={constants.ROOT} to={constants.HOME} />
        <Route component={NotFound} />
      </Switch>
    );
  }

}


export default Routes;